import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { formatUnix } from 'src/helpers/ConvertToTimezone';

export const RecordingSidebar = ({ summary, startTime, audioUrl, audioLoading, audioError }) => {
  if (!summary) return null;

  return (
    <Box
      sx={{
        flexBasis: { xs: '100%', md: '38%' },
        flexShrink: 0,
        position: 'sticky',
        top: { md: 16 },
        alignSelf: 'flex-start',
        maxHeight: { md: 'calc(100vh - 32px)' },
        overflowY: { md: 'auto' },
        mx: 2,
        textAlign: 'left',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography fontWeight="800">Recording:</Typography>
      {audioLoading ? (
        <Box display="flex" alignItems="center" gap={1}>
          <CircularProgress size={20} />
          <Typography>Loading audio…</Typography>
        </Box>
      ) : audioError ? (
        <Typography color="error">{audioError}</Typography>
      ) : audioUrl ? (
        <audio src={audioUrl} controls style={{ width: '100%' }} />
      ) : (
        <Typography color="text.secondary">No recording available.</Typography>
      )}

      <Typography fontWeight="800" mt={1}>
        Call Date:
      </Typography>
      <Typography>{formatUnix(startTime ?? '')}</Typography>

      <Typography fontWeight="800" mt={1}>
        Summary:
      </Typography>
      <Typography>{summary}</Typography>
    </Box>
  );
};
